import PropTypes from 'prop-types';
import './ArticleItem.css';
import ArticleInteractions from './ArticleInteractions';

const ArticleItem = ({ article, user }) => {
  if (!article) {
    return null;
  }

  const handleClick = () => {
    if (article.url) {
      window.open(article.url, '_blank');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return !isNaN(date.getTime())
      ? date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
      : dateString;
  };

  const renderSummary = () => {
    if (typeof article.summary === 'string') {
      const points = article.summary.split(/(?:\r\n|\r|\n)[-•\d.*]*\s*/).filter(point => point.trim() !== '');
  
      if (points.length > 1) {
        return (
          <ul>
            {points.map((point, index) => (
              <li key={index}>{point.trim().replace(/^[-•\d.*]+\s*/, '')}</li>
            ))}
          </ul>
        );
      } else {
        return <p>{article.summary.replace(/^[-•\d.*]+\s*/, '')}</p>;
      }
    } else {
      return <p>No summary available.</p>;
    }
  };

  const getCategoryClass = (category) => {
    const categoryClasses = {
      'General News': 'category-general-news',
      'Global News': 'category-global-news',
      'Business & Finance': 'category-business-finance',
      'Politics': 'category-politics',
      'Sports': 'category-sports',
      'Entertainment': 'category-entertainment',
      'Uncategorized': 'category-uncategorized',
    };
    return categoryClasses[category] || 'category-uncategorized';
  };

  return (
    <div className={`article-item ${getCategoryClass(article.category)}`}>
      <div className="article-metadata">
        <span className="article-source">{article.source || 'Unknown Source'}</span>
        <span className="article-category">{article.category || 'Uncategorized'}</span>
        <span className="article-date">{formatDate(article.date_added)}</span>
      </div>
      <div className="article-content">
        <h2 className="article-title">{article.title || 'Untitled Article'}</h2>
        {renderSummary()}
        <div className="article-footer">
          <button className="article-link-button" onClick={handleClick} disabled={!article.url}>
            Read Article
          </button>
          {user && article.id && <ArticleInteractions articleId={article.id} user={user} articleUrl={article.url} />}
        </div>
      </div>
    </div>
  );
};

ArticleItem.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string,
    source: PropTypes.string,
    category: PropTypes.string,
    date_added: PropTypes.string,
    importance_score: PropTypes.number,
  }),
  user: PropTypes.object,
};

export default ArticleItem;